import React from 'react';
import { useSetAtom } from 'jotai';
import { exploreViewAtom } from '../atoms';
import { Button, Tooltip } from 'antd';
import { BugOutlined } from '@ant-design/icons';
import { APP_ERROR_MODAL_EXPLORE_DIMENSIONS } from '@utils/dimension/appDimensionHelper';

function Header({ column, container }) {
  const setExploreView = useSetAtom(exploreViewAtom);
  const errorDimensions = APP_ERROR_MODAL_EXPLORE_DIMENSIONS.map((d) => d.dimension);

  const handleClick = (columnKey) => {
    setExploreView({
      show: true,
      dimension: columnKey,
    });
  };

  return (
    <>
      {errorDimensions.includes(column.key) && (
        <Tooltip placement="right" title="View errors">
          <Button
            style={{ fontSize: 18, lineHeight: 1, padding: 5 }}
            type="text"
            icon={<BugOutlined />}
            onClick={() => handleClick(column.key)}
          />
        </Tooltip>
      )}
    </>
  );
}

export default Header;
